export const GOOGLE_MAPS_API_KEY: string = 'AIzaSyBW7kV4kjSYtMEfo6TXBTuNywd9KuAg0kQ';
export const GOOGLE_MAPS_STOP_DEFAULT_ZOOM: number = 1;
export const GOOGLE_MAPS_STOP_DETAIL_ZOOM: number = 16;
